import axios from "axios";

const OPT_OUT_LIST_URL =
  "https://stw-optout-phrases.s3.amazonaws.com/prod/phrases.json";

export async function fetchOptOutPhraseList(): Promise<string[]> {
  const response = await axios.get(OPT_OUT_LIST_URL);

  return (
    response.data as {
      id: string;
      phrase: string;
    }[]
  ).map(entry => entry.phrase);
}
